import { GetExcelRequest, GetRequest, PostRequest, PutRequest } from "../../service"

const ControllerName = "BrokerPatient"

export const GetBrokerPatientsListGroups = (searchUrl,isSubmitted=false) =>
    GetRequest(`${ControllerName}${searchUrl}&isSubmited=${isSubmitted}`)

export const GetBrokerPatientsTemplate = () =>
    GetExcelRequest(`${ControllerName}/excel/broker-patients-template`)


export const GetBrokerStats = () =>
    GetRequest(`${ControllerName}/stats`)

export const ImportBrokerPatients = (formData) =>
    PutRequest(`${ControllerName}/excel/import-patients`, formData)


export const SubmitBrokerPatientsRequests = (body) =>
    PostRequest(`${ControllerName}/submit-requests`, body)


export const GetBrokerMissingData = () => 
    GetRequest(`${ControllerName}/get-patient-missing-data`)

export const BrokerPatientUpdateMissingData = (PatientId,attachmentIds) =>
    PostRequest(`${ControllerName}/update-missing-data/${PatientId}`, attachmentIds)



export const addPatientMannually = (body) =>
    PostRequest(`${ControllerName}/add-manual-broker-patient`, body)


export const UpdatePatient = (BrokerPatientId, body) =>
    PutRequest(`${ControllerName}/update-broker-patient-data/${BrokerPatientId}`, body)


export const GetBrokerPatientById = (BrokerPatientId) =>
    GetRequest(`${ControllerName}/get-broker-patient-data/${BrokerPatientId}`)